@if (isPrintView()) {
  <div class="section-header">
    <div class="section-title">
      <ng-container *ngTemplateOutlet="sectionTemplate"></ng-container>
    </div>
  </div>
  <ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
} @else {
  <mat-accordion>
    <mat-expansion-panel class="mat-elevation-z0 section-box">
      <mat-expansion-panel-header class="section-header">
        <mat-panel-title class="section-title">
          <ng-container *ngTemplateOutlet="sectionTemplate"></ng-container>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
    </mat-expansion-panel>
  </mat-accordion>
}

<ng-template #sectionTemplate>
  <div class="location-country-group">
    <app-flag [country]="deliveriesByCountry().value[0].from.address.country"></app-flag>
    <span class="country-name">{{ countryName }} ({{ deliveriesByCountry().value.length }})</span>
  </div>
</ng-template>

<ng-template #contentTemplate>
  @for (delivery of deliveriesByCountry().value; track delivery.id) {
    <app-delivery-report-other-deliveries-delivery-details
      [delivery]="delivery"
      [isPrintView]="isPrintView()"
    ></app-delivery-report-other-deliveries-delivery-details>
  }
</ng-template>
